module.exports = __webpack_public_path__ + "img/Creamy.b3e35928.png";